// extracted by mini-css-extract-plugin
export default {"container":"SetupIPACategoryLevelsOptimizationCategory_container__9IPVy"};